import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import immer from "immer";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useDeleteKey = (projectId, version) => {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);

  const queryKey = [
    "project",
    projectId,
    "version",
    version?.toString(),
    "keys",
  ];
  return useMutation(
    async (key) => {
      await fetchContext.authAxios.delete(`/projects/${projectId}/keys/${key}`);
    },
    {
      onMutate: async (keyId) => {
        await queryClient.cancelQueries(queryKey, {
          exact: false,
        });

        queryClient
          .getQueryCache()
          .findAll(queryKey)
          .forEach(({ queryKey }) => {
            const previousKeys = queryClient.getQueryData(queryKey);
            const newKeys = immer(previousKeys, (draft) => {
              const index = draft.findIndex((key) => key.id === keyId);
              if (index !== -1) draft.splice(index, 1);
            });
            queryClient.setQueryData(queryKey, newKeys);
          });
      },
    }
  );
};
